import React, { useState } from 'react';
import { Modal, Nav, Tab } from 'react-bootstrap';
import { EventWorkbooks } from './EventWorkbooks';
import { EventHomework } from './EventHomework';
import { EventVideos } from './EventVideos';
import { EventQuizzes } from './EventQuizzes';

export const EventDocumentsModal = ({ show, onHide, eventId, communityId, isOwner }) => {
  const [activeTab, setActiveTab] = useState('workbooks');

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold">Class Documents</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-2">
        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
          <Nav variant="pills" className="gap-2 mb-4 overflow-auto flex-nowrap pb-2" style={{ borderBottom: '1px solid #dee2e6' }}>
            <Nav.Item>
              <Nav.Link eventKey="workbooks" className={`rounded-pill px-4 py-2 ${activeTab === 'workbooks' ? 'cd-btn-orange text-white fw-bold' : 'text-dark bg-light'}`}>
                <i className="bi bi-book me-2"></i> Workbooks
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="homework" className={`rounded-pill px-4 py-2 ${activeTab === 'homework' ? 'cd-btn-orange text-white fw-bold' : 'text-dark bg-light'}`}>
                <i className="bi bi-journal-text me-2"></i> Homework
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="videos" className={`rounded-pill px-4 py-2 ${activeTab === 'videos' ? 'cd-btn-orange text-white fw-bold' : 'text-dark bg-light'}`}>
                <i className="bi bi-film me-2"></i> Videos
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="quizzes" className={`rounded-pill px-4 py-2 ${activeTab === 'quizzes' ? 'cd-btn-orange text-white fw-bold' : 'text-dark bg-light'}`}>
                <i className="bi bi-ui-checks me-2"></i> Quizzes
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="workbooks">
              <EventWorkbooks eventId={eventId} communityId={communityId} isOwner={isOwner} />
            </Tab.Pane>
            <Tab.Pane eventKey="homework">
              <EventHomework eventId={eventId} communityId={communityId} isOwner={isOwner} />
            </Tab.Pane>
            <Tab.Pane eventKey="videos">
              <EventVideos eventId={eventId} communityId={communityId} isOwner={isOwner} />
            </Tab.Pane>
            <Tab.Pane eventKey="quizzes">
              <EventQuizzes eventId={eventId} communityId={communityId} isOwner={isOwner} />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
    </Modal>
  );
};
